import {useEffect, useState, useCallback} from "react";
import {useQuery} from "@tanstack/react-query";
import UserStore from "../../store/user-store";
import {apiClient} from "../../AxiosConfig";
import ConfigStore from "../../store/config-store";


const fetchAvailableServers = async () => {
    const response = await apiClient.get(`/v1/servers/`);

    if (response.status === 200) {
        return response.data;
    }
}

export const useFetchServers = () => {
    const {data, isLoading, isSuccess} = useQuery({
        queryKey: ['servers'],
        queryFn: fetchAvailableServers,
        retry: 1,
        enabled: Boolean(UserStore.userAccessToken && UserStore.userActivePlanData),
    });

    // Create a stable callback function that won't change on each render
    const updateServerPings = useCallback((results) => {
        ConfigStore.setServers(results);
    }, []);

    useEffect(() => {
        if (data && isSuccess) {
            // Handle server pings
            pingServers(data, updateServerPings);
        }
    }, [data, isSuccess, updateServerPings]);

    return {data: data, isLoading};
};

// Server ping logic
export async function pingServers(servers, updateServerPings) {


    if (!servers || servers.length === 0) return;
    
    const start = new Date().getTime();


    const promises = servers.map(async (server) => {
        try {
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 300);

            const startTime = new Date().getTime();
            await fetch(`https://${server.server_dns}:9999`, {
                mode: 'cors',
                headers: {
                    'Access-Control-Allow-Origin': '*'
                },
                signal: controller.signal
            });
            const pingTime = new Date().getTime() - startTime;
            

            server.ping = pingTime;
            
            clearTimeout(timeoutId);
        } catch (err) {
            const pingTime = (new Date().getTime() - start > 69)
                ? new Date().getTime() - start - 69
                : new Date().getTime() - start;
            
            server.ping = pingTime;
        }
    });

    await Promise.all(promises);
    
    if (updateServerPings && typeof updateServerPings === 'function') {
        updateServerPings(servers);
    }
}
